import { createContext, useState } from "react";

export const TooltipContext = createContext<any>(null);

const TooltipContextProvider = ({ children }: any) => {

    const [tooltips, setTooltips] = useState<any>(null);

    const add = (value: any) => {
        setTooltips(value);
    }

    const remove = () => {
        setTooltips(null)
    }

    const providers = {
        tooltips,
        add,
        remove
    };
    
    return (
        <TooltipContext.Provider value={providers}>
            {children}
        </TooltipContext.Provider>
    )
};

export default TooltipContextProvider;